import * as React from "react";
import * as R from "ramda";
import {Form} from "react-final-form";
import {Col, Row, Glyphicon} from "react-bootstrap";
import TipoCliente from "../../general/componentes/TipoCliente";
import {connect} from "react-redux";
import {REQUEST} from "../../../config/ajax-wrapper";
import {Mensaje} from "../../general/componentes/Mensaje";
import {DotLoader} from "react-spinners";
import DatePickerSura from "../../general/componentes/DatePicker";
import {TrazaEstado} from "../../documentos/modelo/Documento";
import {obtenerXLSHistorico, consultarHistorico} from "../modulos/reportesActions";
import {FiltroHistoricos} from "../modelo/Historicos";
import NumericInput from "../../general/componentes/NumericInput";
import TipoIdentificacion from "../../general/componentes/TipoIdentificacion";
import TablaHistoricosIndependientes from "./TablaHistoricosIndependientes";
import TablaHistoricosEmpresas from "./TablaHistoricosEmpresas";

class Historicos extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            visualizarTabla: false,
            filtroHistoricos: {}
        };
    }

    render() {
        const {estados, estadoConsulta, estadoXLS, paginas, tamanoPagina, paginaActual} = this.props;
        const {visualizarTabla} = this.state;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({handleSubmit, invalid, errors, form, submitting, pristine, values}) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Reporte Historicos</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar histórico de la trazabilidad del formulario</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        
                                        {this.renderFiltros(values)}

                                        <Row className="form-group">
                                            <Col sm={2}>
                                                {estados.length > 0 && visualizarTabla &&
                                                <a onClick={this.obtenerXLS} className="btns btn-success">
                                                    <Glyphicon className={"save-file"}
                                                               glyph={"save-file"}/> Exportar XLS

                                                </a>}
                                            </Col>
                                            <Col smOffset={6} sm={1}>
                                                <button type="button" className="btns btns-link"
                                                        onClick={form.reset}
                                                        disabled={submitting}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={1}>
                                                <button type="submit" className="btns btns-primary"
                                                        disabled={submitting || invalid}>
                                                    Consultar
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderXLS(estadoXLS)}
                    {this.renderDocumentos(estados, estadoConsulta, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    renderFiltros(values: any) {
        return(
            <div>
                <Row className="form-group">                                    
                    <Col sm={3}>
                        <label htmlFor="tipoDocumento">{values.tipoCliente === 'OI' ? 'Tipo Documento del Independiente':'Tipo Documento'}</label>
                        <TipoIdentificacion name="tipoDocumento" excluir={values.tipoCliente === 'OI' ? ["NI"]:[]}/>
                    </Col>
                    <Col sm={3}>
                        <label htmlFor="documento">{values.tipoCliente === 'OI' ? 'Documento del Independiente':'Documento'}</label>
                        <NumericInput name="documento" placeholder="Ingrese un documento"/>
                    </Col>
                    <Col sm={3}>
                        <label>Fecha Inicio</label>
                        <DatePickerSura name={"fechaInicio"}/>
                    </Col>
                    <Col sm={3}>
                        <label>Fecha Fin</label>
                        <DatePickerSura name={"fechaFin"}/>
                    </Col>
                </Row>
                <Row className="form-group">
                    <Col sm={3}>
                        <label>Tipo Cliente</label>
                        <TipoCliente name="tipoCliente" excluir={["DE"]}/>
                    </Col>
                    {
                        values.tipoCliente === 'OI' && 
                        <div>
                            <Col sm={3}>
                                <label htmlFor="tipoDocumentoEmpresa">Tipo Documento del Contratante</label>
                                <TipoIdentificacion name="tipoDocumentoEmpresa"/>
                            </Col>
                            <Col sm={3}>
                                <label htmlFor="documentoEmpresa">Documento del Contratante</label>
                                <NumericInput name="documentoEmpresa" placeholder="Ingrese un documento"/>
                            </Col>
                        </div>
                    }
                </Row>
            </div>
        );
    }

    renderXLS = (estado: REQUEST) => {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error generando el XLS"}/>;
            case REQUEST.PENDING:
                return <DotLoader size={25}/>;
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"} mensaje={"Reporte generado exitosamente"}/>
                    </span>
                );
            default:
                return false;
        }
    };

    renderDocumentos(estados: Array<TrazaEstado>, estado: REQUEST,paginas: number, tamanoPagina: number, paginaActual: number) {
        const {visualizarTabla} = this.state; 
        if(visualizarTabla) {
            switch (estado) {
                case REQUEST.ERROR:
                    return <Mensaje type={"danger"} mensaje={"Se ha presentado un error obteniendo el reporte"}/>;
                case REQUEST.PENDING:
                    return <DotLoader size={25}/>;
                case REQUEST.SUCCESS:
                    if (!estados || !estados.length) {
                        return (
                            <span>
                                <Mensaje type={"danger"} mensaje={"No hemos encontrado documentos :("}/>
                            </span>
                        );
                    } else {
                        switch (this.state.filtroHistoricos.tipoCliente) {
                            case 'OI': {
                                return (
                                    <span>
                                        <TablaHistoricosIndependientes 
                                            estados={estados}
                                            filtroDocumento={this.filtros()}
                                            consultaPaginada={this.consultaPaginada}
                                            paginas={paginas} 
                                            tamanoPagina={tamanoPagina}
                                            paginaActual={paginaActual} 
                                        />
                                    </span>
                                );
                            }
                            default: {
                                return (
                                    <span>
                                        <TablaHistoricosEmpresas 
                                            estados={estados}
                                            filtroDocumento={this.filtros()}
                                            consultaPaginada={this.consultaPaginada}
                                            paginas={paginas} 
                                            tamanoPagina={tamanoPagina}
                                            paginaActual={paginaActual} 
                                        />
                                    </span>
                                );
                            }
                        }
                    }
                default:
                    return false;
            }
        } else 
            return false;
    }

    validate = values => {
        switch (values.tipoCliente) {
            case 'OI': {
                return this.validarFiltrosIndependientes(values);
            }
            default: {
                return this.validarFiltrosEmpresas(values);
            } 
        }
    };

    validarFiltrosEmpresas(values: any) {
        const errors = {
            documento: undefined, 
            tipoDocumento: undefined, 
            fechaInicio: undefined, 
            fechaFin: undefined
        };

        if (values.tipoDocumento && !values.documento) 
            errors.documento = "Por favor ingrese un documento";

        if (!values.tipoDocumento && values.documento)
            errors.tipoDocumento = "Por favor selecciona un tipo de documento";

        if (values.fechaInicio && !values.fechaFin)
            errors.fechaFin = "Por favor selecciona una fecha de fin";

        if (!values.fechaInicio && values.fechaFin)
            errors.fechaInicio = "Por favor selecciona una fecha de inicio";

        if (values.fechaInicio && values.fechaFin && values.fechaInicio.isAfter(values.fechaFin))
            errors.fechaFin = "La fecha fin no puede ser anterior a la fecha de inicio";

        if( !values.fechaInicioAprobacion && !values.fechaInicio)
            errors.fechaInicio = "Por favor seleccione una fecha como filtro para continuar";

        return errors;
    }

    validarFiltrosIndependientes(values: any) {
        const errors = {
            documento: undefined, 
            tipoDocumento: undefined, 
            documentoEmpresa: undefined, 
            tipoDocumentoEmpresa: undefined, 
            fechaInicio: undefined, 
            fechaFin: undefined
        };

        if (values.tipoDocumento && !values.documento)
            errors.documento = "Por favor ingrese un documento";

        if (!values.tipoDocumento && values.documento)
            errors.tipoDocumento = "Por favor selecciona un tipo de documento";

        if (values.tipoDocumentoEmpresa && !values.documentoEmpresa)
            errors.documentoEmpresa = "Por favor ingrese un documento";
        
        if (!values.tipoDocumentoEmpresa && values.documentoEmpresa)
            errors.tipoDocumentoEmpresa = "Por favor selecciona un tipo de documento";

        if (values.fechaInicio && !values.fechaFin) {
            errors.fechaFin = "Por favor selecciona una fecha de fin";
        }

        if (!values.fechaInicio && values.fechaFin) {
            errors.fechaInicio = "Por favor selecciona una fecha de inicio";
        }

        if (values.fechaInicio && values.fechaFin &&
            (values.fechaInicio.isAfter(values.fechaFin))) {
            errors.fechaFin = "La fecha fin no puede ser anterior a la fecha de inicio";
        }

        if( !values.fechaInicioAprobacion && !values.fechaInicio) {
            errors.fechaInicio = "Por favor seleccione una fecha como filtro para continuar";
        }

        return errors;
    }

    onSubmit = values => {
        const dni = values.tipoDocumento && values.documento ? (values.tipoDocumento + values.documento) : undefined;
        const dniEmpleador = values.tipoDocumentoEmpresa && values.documentoEmpresa && values.tipoCliente === 'OI' ? (values.tipoDocumentoEmpresa + values.documentoEmpresa) : undefined;
        const tipoCliente = values.tipoCliente ? values.tipoCliente.valueOf() : "";
        const estado = values.estado ? values.estado.valueOf() : "";
        const fechaInicio = values.fechaInicio ? values.fechaInicio.valueOf() : "";
        const fechaFin = values.fechaFin ? values.fechaFin.valueOf() : "";
        const pagina = 0;
        const filtro: FiltroHistoricos = {
            dni : dni,
            dniEmpleador: dniEmpleador,
            tipoCliente: tipoCliente,
            estado : estado,
            fechaFin: fechaFin, 
            fechaInicio: fechaInicio,
            registrosPorPagina : this.props.tamanoPagina,
            pagina: pagina
        };
        this.setState({filtroHistoricos: filtro, visualizarTabla: true});
        this.props.dispatch(consultarHistorico(filtro));
    };

    consultaPaginada = (filtro: FiltroHistoricos) => {
        this.props.dispatch(consultarHistorico(filtro));
    };


    filtros(): FiltroHistoricos {
        switch (this.state.filtroHistoricos.tipoCliente) {
            case 'OI': {
                return { 
                    dni: this.state.filtroHistoricos.dni,
                    dniEmpleador: this.state.filtroHistoricos.dniEmpleador,
                    tipoCliente:this.state.filtroHistoricos.tipoCliente,
                    estado: this.state.filtroHistoricos.estado,
                    fechaInicio: this.state.filtroHistoricos.fechaInicio,
                    fechaFin: this.state.filtroHistoricos.fechaFin
                };
            }
            default: {
                return { 
                    dni: this.state.filtroHistoricos.dni,
                    tipoCliente:this.state.filtroHistoricos.tipoCliente,
                    estado: this.state.filtroHistoricos.estado,
                    fechaInicio: this.state.filtroHistoricos.fechaInicio,
                    fechaFin: this.state.filtroHistoricos.fechaFin
                };
            }
        }
    }

    limpiar = () => {
        this.setState({
            filtroHistoricos: {}
        });
    };

    obtenerXLS = () => {
        this.props.dispatch(obtenerXLSHistorico(this.state.filtroHistoricos));
    }
}

export default connect((store: any) => {
    return {
        estados: R.pathOr([], ["reportes", "estados"])(store),
        estadoConsulta: R.pathOr([], ["reportes", "estado"])(store),
        estadoXLS: R.pathOr([], ["reportes", "estadoXLS"])(store),
        tamanoPagina: R.pathOr(10, ["reportes", "tamanoPagina"])(store),
        paginaActual: R.pathOr(1, ["reportes", "paginaActual"])(store),
        paginas: R.pathOr(1, ["reportes", "paginas"])(store)
    };
})(Historicos);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/componentes/Historicos.tsx